export default "__VITE_PUBLIC_ASSET__f586c634__"